<template>
  <SoAlert v-if="showWarning" type="warning" class="mb-4" :text="message" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: {
      SoAlert,
    },
    props: {
      message: {
        type: String,
        default:
          "This feature does not have a dev environment and should not be used in staging for testing. Please test locally only.",
      },
    },
    computed: {
      showWarning(): boolean {
        return __APP_ENV__ !== "production"
      },
    },
  })
</script>
